mutation updateInventorySettings(
  $email: String!
  $daysToNotifyBeforeRunOut: Int!
  $pastDaysUsedForCalculation: Int!
  $xeroConfig: AdminUpdateInventorySettingsXeroConfigInput!
) {
  updateInventorySettings(
    email: $email
    daysToNotifyBeforeRunOut: $daysToNotifyBeforeRunOut
    pastDaysUsedForCalculation: $pastDaysUsedForCalculation
    xeroConfig: $xeroConfig
  ) {
    email
    daysToNotifyBeforeRunOut
    pastDaysUsedForCalculation
    xeroConfig {
      isTokenSetValid
      authConsentUrl
      inventoryAssetAccountCode
      inventoryAdjustmentAccountCode
      inventoryCogsAccountCode
      inventoryContactName
      alertEmail
    }
  }
}
